export default __webpack_public_path__ + "static/media/2_0042.34c96058.webp";